import script from "./HrMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HrMenu.vue?vue&type=script&setup=true&lang=js"

import "./HrMenu.vue?vue&type=style&index=0&id=6dc17cbe&lang=scss"

const __exports__ = script;

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QMenu});
